import React from 'react';
import classes from '../styles/loader.css';

const loader = () => <div className={classes.Loader}>Loading...</div>;

export default loader;
